// src/components/Footer.js
import { Link } from 'react-router-dom';
import { FiFacebook, FiTwitter, FiLinkedin, FiGithub, FiInstagram } from 'react-icons/fi';
import { SignedIn, SignedOut, SignInButton, UserButton, useUser } from '@clerk/clerk-react';
import { useSiteConfig } from '../hooks/useSiteConfig';

function Footer() {
  const { user } = useUser();
  const { config } = useSiteConfig();
  const isAdmin = user?.publicMetadata?.role === 'admin';
  const links = config.socialLinks || {};

  return (
    <footer id="footer" className="footer">
      <div id="footer-inner" className="footer-inner">

        {/* Brand */}
        <div id="footer-brand" className="footer-brand">
          <img id="footer-logo" className="footer-logo" src={config.logoUrl || '/logo.png'} alt="CSdevs logo" />
        </div>

        {/* Nav Links */}
        <nav id="footer-nav" className="footer-nav">
          <p className="footer-nav-heading">Pages</p>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
        </nav>

        {/* Social */}
        <div id="footer-social" className="footer-social">
          <p className="footer-nav-heading">Follow Us</p>
          <div className="footer-social-icons">
            {links.facebook && <a href={links.facebook} id="social-facebook" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><FiFacebook size={20} /></a>}
            {links.twitter && <a href={links.twitter} id="social-twitter" aria-label="Twitter" target="_blank" rel="noopener noreferrer"><FiTwitter size={20} /></a>}
            {links.linkedin && <a href={links.linkedin} id="social-linkedin" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer"><FiLinkedin size={20} /></a>}
            {links.github && <a href={links.github} id="social-github" aria-label="GitHub" target="_blank" rel="noopener noreferrer"><FiGithub size={20} /></a>}
            {links.instagram && <a href={links.instagram} id="social-instagram" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><FiInstagram size={20} /></a>}
          </div>
        </div>

      </div>

      {/* Bottom bar */}
      <div id="footer-bottom" className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} CS Devs. All rights reserved.</p>
        <div className="footer-auth">
          <SignedOut><SignInButton mode="modal"><button className="btn-auth">Log in</button></SignInButton></SignedOut>
          <SignedIn>
            {isAdmin && <Link to="/admin" className="btn-auth" style={{ marginRight: '0.75rem', textDecoration: 'none' }}>Dashboard</Link>}
            <UserButton />
          </SignedIn>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
